export default __webpack_public_path__ + "static/iKeepSafe-FERPA-seal-0195bc8f663f50255ab380e14bd9c1ab.png";